// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(import.meta.env.VITE_APP_BASE_URL)
// ** START:  
export const getAcctgCOAListF01Data = createAsyncThunk('appAcctgCOA/getAcctgCOAListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        if (!state.acctgCOA.COAListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/acctg-coa/get-acctg-coa-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getAcctgCOAListF01', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /acctg-coa/getAcctgCOAListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.acctgCOA.COAListF01.allData
            tempIsDataLoaded = state.acctgCOA.COAListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:

        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            if (a[sortColumn]) {
                return a[sortColumn] < b[sortColumn] ? -1 : 1
            } else {
                const splitColumn = sortColumn.split('.')
                const columnA = a[splitColumn[0]][splitColumn[1]]
                const columnB = b[splitColumn[0]][splitColumn[1]]
                return columnA < columnB ? -1 : 1
            }
        })

        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            acctgCOA => { 
                return ((acctgCOA.name.toLowerCase().includes(queryLowered) ||
                        acctgCOA.contact.toLowerCase().includes(queryLowered) ||
                        acctgCOA.email.toLowerCase().includes(queryLowered)) 
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const acctgCOAListF01Slice = createSlice({
    name: 'acctgCOAListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getAcctgCOAListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getAcctgCOAListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getAcctgCOAListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getAcctgCOAListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getAcctgCOARowF01Data = createAsyncThunk('appAcctgCOA/getAcctgCOARowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/acctg-coa/get-acctg-coa-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getAcctgCOARowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getAcctgCOARowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const acctgCOARowF01Slice = createSlice({
    name: 'acctgCOARowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getAcctgCOARowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getAcctgCOARowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getAcctgCOARowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getAcctgCOARowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateAcctgCOA = createAsyncThunk('appAcctgCOA/updateAcctgCOA', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/acctg-coa/update-acctg-coa/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const acctgCOAUpdateSlice = createSlice({
    name: 'acctgCOAUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateAcctgCOA.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateAcctgCOA.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateAcctgCOA.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateAcctgCOA:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createAcctgCOA = createAsyncThunk('appAcctgCOA/createAcctgCOA', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/acctg-coa/create-acctg-coa`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const acctgCOACreateSlice = createSlice({
    name: 'acctgCOACreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createAcctgCOA.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createAcctgCOA:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createAcctgCOA.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createAcctgCOA.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createAcctgCOA\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteAcctgCOA = createAsyncThunk('appAcctgCOA/deleteAcctgCOA', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/acctg-coa/delete-acctg-coa/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const acctgCOADeleteSlice = createSlice({
    name: 'acctgCOADeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteAcctgCOA.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteAcctgCOA.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteAcctgCOA.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteAcctgCOA:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Export actions
export const { setIsDataLoaded } = acctgCOAListF01Slice.actions
export const { resetCreateState } = acctgCOACreateSlice.actions

// Combine reducers
const acctgCOAReducer = combineReducers({
    acctgCOAListF01: acctgCOAListF01Slice.reducer,
    acctgCOARowF01: acctgCOARowF01Slice.reducer,
    acctgCOACreate: acctgCOACreateSlice.reducer,
    acctgCOAUpdate: acctgCOAUpdateSlice.reducer,
    acctgCOADelete: acctgCOADeleteSlice.reducer
})


export default acctgCOAReducer